export const EndPoints = {
  RESET_PASSWORD: {
    FRANCHISE_UPDATE: "medicity/master/reset_password/franchisemaster",
    EMPLOYEE_UPDATE: "hrms/master/reset_password/employee",
    AGENT_UPDATE: "hrms/master/reset_password/patient_coordinator_agent/",
  },
  PatientGraph: {
    GRAPHSTATSLIST: "reports/dashboard/stats",
    PATIENTLIST: "reports/dashboard/patient_graph",
    HEADER_DETAILS: "medicitydashboard/header/details",
  },
  EmployeeCatergory: {
    LIST: "hrms/employees/category/dropdown",
  },
  City: {
    LIST: "medicity/city/master",
  },
  Franchise: {
    CREATE: "medicity/create/franchise/master",
    LIST: "medicity/franchise_master/master/list",
    ONLY_PARENT_FRANCHISE_LIST:
      "medicity/franchise_master/master/ony_parent_franchise_dd",
    LIST_DD: "medicity/franchise_master/master/franchise_dd",
    LIST_BY_ID: "medicity/master/list/franchisemaster_by_id",
    EXISTS_USERNAME: "hrms/master/employee/exists_username/",
    UPDATE: "medicity/master/update/franchisemaster",
    ACTIVE: "medicity/master/update/franchisemaster/activate_franchise",
    DELETE: "medicity/master/delete/franchisemaster",
    DOWNLOAD_CSV: "medicity/master/franchisemaster/downloadcsv",
    ALLOT_BARCODE: "medicity/franchise/allot_barcodes",
    COPY_RATES_LOG_LIST: "medicity/master/list/franchise_copy_rates_log",
    FRANCHISE_TOP_PERFORMER:
      "reports/franchise/business/date_wise_top_performers",
  },
  PackageInvestigationMaster: {
    CREATE: "medicity/master/create/packageinvestigationmaster",
    LIST: "medicity/master/list/packageinvestigationmaster",
    UPDATE: "medicity/master/update/packageinvestigationmaster",
    DELETE: "medicity/master/delete/packageinvestigationmaster",
    DOWNLOAD_CSV: "medicity/master/packageinvestigationmaster/downloadcsv",
  },
  PatientReceipt: {
    LIST: "medicity/master/list/patientappointment_full_detail",
  },
  PatientSettlement: {
    CREATE:
      "medicity/master/create/capture_patient_appointment_balance_payment",
  },
  PatientAppointmentDetails: {
    CREATE: "medicity/master/create/patientappointmentdetail",
    LIST: "medicity/master/list/patientappointmentdetail",
    SAMPLE_REJECTED_LIST:
      "medicity/master/list/patientappointment_list_rejected_sample_data",
    UPDATE: "medicity/master/update/patientappointmentdetail",
    DELETE: "medicity/master/delete/patientappointmentdetail",
    DOWNLOAD_CSV: "medicity/master/patientappointmentdetail/downloadcsv",
    CHANGE_FRANCHISE:
      "medicity/master/update/patientappointment/change_franchise",
    CHANGE_BARCODE: "medicity/master/update/patientappointment/change_barcode",
    GET_SAMPLEWISE_BARCODE:
      "medicity/master/get/patientappointment/get_samplewise_barcode",
    CANCELLATION:
      "medicity/master/cancel/patientappointmentdetail/investigations",
  },
  PackageInvestigation: {
    CREATE: "medicity/master/create/packageinvestigation",
    PACKAGELIST: "medicity/master/list/investigation/",
    LIST: "medicity/master/list/packagemaster",
    UPDATE: "medicity/master/update/packagemaster",
    DELETE: "medicity/master/delete/packagemaster",
    DOWNLOAD_CSV: "medicity/master/packagemaster/downloadcsv",
  },
  InvestigationSequence: {
    CREATE: "medicity/master/create/investigation_sequencemaster",
    BULKUPDATE: "medicity/master/bulkupdate/investigation_sequencemaster",
    LIST: "medicity/master/list/all_investigation_list",
    SEQUENCE: "medicity/master/list/investigation_sequencemaster",
    UPDATE: "medicity/master/update/investigation_sequencemaster",
    DELETE: "medicity/master/delete/investigation_sequencemaster",
    DOWNLOAD_CSV: "medicity/master/investigation_sequencemaster/downloadcsv",
  },
  InvestigationObservation: {
    CREATE: "medicity/master/create/investigation_observationmaster",
    LIST: "medicity/master/list/investigation_observationmaster",
    MULTIPLEOBSERVATIONlIST: "medicity/master/list/observationmaster_dd",
    UPDATE: "medicity/master/update/investigation_observationmaster",
    DELETE: "medicity/master/delete/investigation_observationmaster",
    DOWNLOAD_CSV: "medicity/master/investigation_observationmaster/downloadcsv",
  },
  Organism: {
    CREATE: "medicity/master/create/organismmaster",
    LIST: "medicity/master/list/organismmaster",
    UPDATE: "medicity/master/update/organismmaster",
    DELETE: "medicity/master/delete/organismmaster",
    DOWNLOAD_CSV: "medicity/master/organismmaster/downloadcsv",
  },
  DoctorsSepcialization: {
    CREATE: "medicity/master/create/doctor_specializationmaster",
    LIST: "medicity/master/list/doctor_specializationmaster",
    UPDATE: "medicity/master/update/doctor_specializationmaster",
    DELETE: "medicity/master/delete/doctor_specializationmaster",
    DOWNLOAD_CSV: "medicity/master/doctor_specializationmaster/downloadcsv",
  },
  DoctorsDegree: {
    CREATE: "medicity/master/create/doctor_degreemaster",
    LIST: "medicity/master/list/doctor_degreemaster",
    UPDATE: "medicity/master/update/doctor_degreemaster",
    DELETE: "medicity/master/delete/doctor_degreemaster",
    DOWNLOAD_CSV: "medicity/master/doctor_degreemaster/downloadcsv",
  },
  DiscountReason: {
    CREATE: "medicity/master/create/discount_reasonmaster",
    LIST: "medicity/master/list/discount_reasonmaster",
    UPDATE: "medicity/master/update/discount_reasonmaster",
    DELETE: "medicity/master/delete/discount_reasonmaster",
    DOWNLOAD_CSV: "medicity/master/discount_reasonmaster/downloadcsv",
  },
  FranchiseType: {
    CREATE: "medicity/master/create/franchisetypes",
    LIST: "medicity/master/list/franchisetypes",
    UPDATE: "medicity/master/update/franchisetypes",
    DELETE: "medicity/master/delete/franchisetypes",
    DOWNLOAD_CSV: "medicity/master/franchisetypes/downloadcsv",
  },
  DepartmentType: {
    CREATE: "medicity/master/create/departmenttypemaster",
    LIST: "medicity/master/list/departmenttypemaster",
    UPDATE: "medicity/master/update/departmenttypemaster",
    DELETE: "medicity/master/delete/departmenttypemaster",
    DOWNLOAD_CSV: "medicity/master/departmenttypemaster/downloadcsv",
  },
  LabDepartment: {
    CREATE: "medicity/master/create/labdepartmentmaster",
    LIST: "medicity/master/list/labdepartmentmaster",
    UPDATE: "medicity/master/update/labdepartmentmaster",
    DELETE: "medicity/master/delete/labdepartmentmaster",
    DOWNLOAD_CSV: "medicity/master/labdepartmentmaster/downloadcsv",
  },
  CollectionType: {
    CREATE: "medicity/master/create/collectiontypemaster",
    LIST: "medicity/master/list/collectiontypemaster",
    UPDATE: "medicity/master/update/collectiontypemaster",
    DELETE: "medicity/master/delete/collectiontypemaster",
    DOWNLOAD_CSV: "medicity/master/collectiontypemaster/downloadcsv",
  },
  Circular: {
    CREATE: "medicity/master/create/circularmaster",
    LIST: "medicity/master/list/circularmaster",
    UPDATE: "medicity/master/update/circularmaster",
    DELETE: "medicity/master/delete/circularmaster",
    DOWNLOAD_CSV: "medicity/master/circularmaster/downloadcsv",
  },
  BRANCH: {
    CREATE: "hrms/master/create/branch",
    LIST: "hrms/master/list/branch",
    UPDATE: "hrms/master/update/branch",
    DELETE: "hrms/master/delete/branch",
    DOWNLOAD_CSV: "hrms/master/branch/downloadcsv",
  },
  Zone: {
    CREATE: "medicity/master/create/zone",
    LIST: "medicity/zone/master",
    LIST_BY_ID: "medicity/master/list/zonemaster/zone_detail",
    UPDATE: "medicity/master/update/zonemaster",
    DELETE: "medicity/master/delete/zonemaster",
    DOWNLOAD_CSV: "medicity/master/zonemaster/downloadcsv",
    ZONE_LOGO_BY_ID: "medicity/master/zonemaster/download_zone_logo",
  },
  Area: {
    CREATE: "medicity/master/create/areamaster",
    LIST: "medicity/master/list/areamaster",
    UPDATE: "medicity/master/update/areamaster",
    DELETE: "medicity/master/delete/areamaster",
    DOWNLOAD_CSV: "medicity/master/areamaster/downloadcsv",
  },
  // CREATEDEPARTMENT: "hrms/master/create/department",
  // CREATEBRANCH: "hrms/master/create/branch",
  // STATEBYCOUNTRY: "medicity/get_state/",
  // CITYBYSTATE: "medicity/get_city/",
  // ZONELIST: "medicity/zone/master",
  ZONELISTDD: "medicity/zone/master/zone_dd",
  // CREATEROLE: "hrms/master/create/roles",
  // CREATEDESIGNATION: "hrms/master/create/designation",
  // GETDEPARTMENT: "hrms/master/list/department",
  // PANELTYPEMASTER: "medicity/master/create/franchisetypes",
  // ADDZONEMASTER: "medicity/master/create/zone",
  // ADDAREAMASTER: "medicity/master/create/areamaster",
  // ADDCIRUCLARMASTER: "medicity/master/create/circularmaster",
  // DISCOUNTMASTER: "medicity/master/create/discount_reasonmaster",
  // DOCTORMASTER: "medicity/master/create/doctor_degreemaster",
  // DOCTORSPECIALIZATION: "medicity/master/create/doctor_specializationmaster",
  // BRANCHLISTING: "hrms/master/list/branch/",
  // DELETEBRANCH: "hrms/master/delete/branch/",
  SAMPLESTATUS: "medicity/master/list/appointmentstatusmaster",
  DEPARTMENT: {
    CREATE: "hrms/master/create/department",
    LIST: "hrms/master/list/department",
    UPDATE: "hrms/master/update/department",
    DELETE: "hrms/master/delete/department",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  DESIGNATION: {
    CREATE: "hrms/master/create/designation",
    LIST: "hrms/master/list/designation",
    UPDATE: "hrms/master/update/designation",
    DELETE: "hrms/master/delete/designation",
    DOWNLOAD_CSV: "hrms/master/designation/downloadcsv",
  },
  EMPLOYEE: {
    CREATE: "hrms/master/create/employee",
    LIST: "hrms/master/list/employee",
    UPDATE: "hrms/master/update/employee",
    DELETE: "hrms/master/delete/employee",
    DOWNLOAD_CSV: "hrms/master/employee/downloadcsv",
    ACTIVE: "hrms/master/update/employee/activate_employee",
  },
  EMPLOYEETYPE: {
    CREATE: "hrms/master/create/employeetypes",
    LIST: "hrms/master/list/employeetypes",
    UPDATE: "hrms/master/update/employeetypes",
    DELETE: "hrms/master/delete/employeetypes",
    DOWNLOAD_CSV: "hrms/master/employeetypes/downloadcsv",
  },
  EMPLOYEECATEGORY: {
    CREATES: "hrms/master/create/employeecategory",
    CREATE: "hrms/master/create/employeecategorymaster",
    LIST: "hrms/master/list/employeecategorymaster",
    UPDATE: "hrms/master/update/employeecategorymaster",
    DELETE: "hrms/master/delete/employeecategorymaster",
    DOWNLOAD_CSV: "hrms/master/employeecategorymaster/downloadcsv",
  },
  DISCOUNTREASON: {
    CREATE: "medicity/master/create/discount_reasonmaster",
    LIST: "medicity/master/list/discount_reasonmaster",
    UPDATE: "medicity/master/update/discount_reasonmaster",
    DELETE: "medicity/master/delete/discount_reasonmaster",
    DOWNLOAD_CSV: "medicity/master/discount_reasonmaster/downloadcsv",
  },
  PAYMENTMODE: {
    CREATE: "accounts/master/create/paymentmodemaster",
    LIST: "accounts/master/list/paymentmodemaster",
    UPDATE: "accounts/master/update/paymentmodemaster",
    DELETE: "accounts/master/delete/paymentmodemaster",
    DOWNLOAD_CSV: "accounts/master/paymentmodemaster/downloadcsv",
  },
  ADVANCEPAYMENT: {
    CREATE: "accounts/master/create/franchiseadvancepaymentmaster",
    UPDATE: "accounts/master/update/franchiseadvancepaymentmaster",
    BULK_UPDATE: "accounts/master/bulkupdate/franchiseadvancepaymentmaster",
    LIST: "accounts/master/list/franchiseadvancepaymentmaster",
    DELETE: "accounts/master/delete/franchiseadvancepaymentmaster",
    DOWNLOAD_CSV: "accounts/master/franchiseadvancepaymentmaster/downloadcsv",
    APPOINTMENT_PAYMENT_UPDATE:
      "medicity/master/update/patient_appointment_payment_detail/",
  },
  ROLE: {
    CREATE: "hrms/master/create/roles",
    LIST: "hrms/master/list/roles",
    UPDATE: "hrms/master/update/roles/",
    DELETE: "hrms/master/delete/roles",
    DOWNLOAD_CSV: "hrms/master/roles/downloadcsv",
  },
  DOCUMENT: {
    CREATE: "medicity/master/create/documentmaster",
    LIST: "medicity/master/list/documentmaster",
    UPDATE: "medicity/master/update/documentmaster",
    DELETE: "medicity/master/delete/documentmaster",
    DOWNLOAD_CSV: "medicity/master/documentmaster/downloadcsv",
  },
  SAMPLECOLLECTION: {
    LIST: "medicity/master/sample/list",
    CREATE: "medicity/master/sample/mark_collect_and_received",
    MACHINE_CREATE: "medicity/master/sample/print_sample_label_for_machine",
    SAMPLEINFORMATION: "medicity/new/registration/get_registration_detail",
  },
  SHARETYPE: {
    CREATE: "medicity/master/create/sharetypemaster",
    LIST: "medicity/master/list/sharetypemaster",
    UPDATE: "medicity/master/update/sharetypemaster",
    DELETE: "medicity/master/delete/sharetypemaster",
    DOWNLOAD_CSV: "medicity/master/sharetypemaster/downloadcsv",
  },
  SAMPLETYPE: {
    CREATE: "medicity/master/create/sampletypemaster",
    LIST: "medicity/master/list/sampletypemaster",
    UPDATE: "medicity/master/update/sampletypemaster",
    DELETE: "medicity/master/delete/sampletypemaster",
    DOWNLOAD_CSV: "medicity/master/sampletypemaster/downloadcsv",
    UPLOAD_VOIL_IMAGE: "medicity/master/sampletypemaster/upload_voil_image",
    GET_VOIL_IMAGE: "medicity/master/sampletypemaster/download_voil_image",
  },
  SAMPLEREJECTIONREASON: {
    CREATE: "medicity/master/create/samplerejectionreasonmaster",
    LIST: "medicity/master/list/samplerejectionreasonmaster",
    UPDATE: "medicity/master/update/samplerejectionreasonmaster",
    DELETE: "medicity/master/delete/samplerejectionreasonmaster",
    DOWNLOAD_CSV: "medicity/master/samplerejectionreasonmaster/downloadcsv",
  },
  PAYMENTTYPE: {
    CREATE: "accounts/master/create/paymenttypemaster",
    LIST: "accounts/master/list/paymenttypemaster",
    UPDATE: "accounts/master/update/paymenttypemaster",
    DELETE: "accounts/master/delete/paymenttypemaster",
    DOWNLOAD_CSV: "accounts/master/paymenttypemaster/downloadcsv",
  },
  INVESTIGATIONTEST: {
    CREATE: "medicity/master/create/investigationmaster",
    LIST: "medicity/master/list/investigationmaster",
    LIST_DD: "medicity/master/list/investigationmaster_dd",
    UPDATE: "medicity/master/update/investigationmaster",
    DELETE: "medicity/master/delete/investigationmaster",
    DOWNLOAD_CSV: "medicity/master/investigationmaster/downloadcsv",
  },
  INVESTIGATIONMANAGER: {
    CREATEHELPMENULIST: "medicity/master/create/investigation_helpmaster",
    CREATEINVESTIGATIONINTERPRETATIONLIST:
      "medicity/master/create/investigation_ineterpretationmaster",
    CREATEOBSERVATIONLIST:
      "medicity/master/bulkcreate/investigation_observationmaster",
    OBSERVATIONLIST: "medicity/master/list/observationmaster_dd",
    CREATE: "medicity/create/full/investigationmaster",
    CREATEINVESTIGATIONLIST:
      "medicity/master/create/investigation_commentmaster",
    LIST: "medicity/master/list/investigationmaster",
    UPDATE: "medicity/master/update/fullinvestigationmaster",
    DELETE: "medicity/master/delete/investigationmaster",
    DOWNLOAD_CSV: "medicity/master/investigationmaster/downloadcsv",
    INVESTIGATION_OBSERVATION_LIST:
      "medicity/master/list/investigation_observationmaster",
    UPDATE_INVESTIGATION_OBSERVATION_LIST:
      "medicity/master/bulkupdate/observationmaster_only/",
    DELETE_INVESTIGATION_OBSERVATION_LIST:
      "medicity/master/delete/investigation_observationmaster",
    INVESTIGATION_COMMENT_LIST:
      "medicity/master/list/investigation_commentmaster",
    INVESTIGATION_INTERPRETATION_LIST:
      "medicity/master/list/investigation_ineterpretationmaster",
    INVESTIGATION_HELP_MENU_LIST:
      "medicity/master/list/investigation_helpmaster",
    INVESTIGATION_OBSERVATION_RANGES_LIST:
      "medicity/master/list/investigation_observations_and_ranges",
    UPDATE_INVESTIGATION_OBSERVATION_SEQUENCE:
      "medicity/master/bulkupdate/investigation_observation_sequence/",
    SHOW_DUMMY_REPORT_DATA:
      "medicity/list/full_investigation/show_dummy_data_for_sample_pdf",
    ACTIVE: "medicity/master/update/activate_investigationmaster",
  },
  INVESTIGATION_OBSERVATION_FORMULA: {
    CREATE: "medicity/master/create/observationformula",
    UPDATE: "medicity/master/update/observationformula",
    LIST: "medicity/master/list/observationformula",
    DELETE: "medicity/master/delete/observationformula",
  },
  INVESTIGATIONTEMPLATE: {
    CREATE: "medicity/master/create/investigation_templatemaster",
    LIST: "medicity/master/list/investigation_templatemaster",
    LIST_BY_ID: "medicity/master/list/investigation_templatemaster",
    UPDATE: "medicity/master/update/investigation_templatemaster",
    DELETE: "medicity/master/delete/investigation_templatemaster",
    DOWNLOAD_CSV: "medicity/master/investigation_templatemaster/downloadcsv",
  },
  EMPDISCOUNTALLOWED: {
    CREATE: "medicity/master/create/employee_discount_allowedmaster",
    LIST: "medicity/master/list/employee_discount_allowedmaster",
    UPDATE: "medicity/master/update/employee_discount_allowedmaster",
    DELETE: "medicity/master/delete/employee_discount_allowedmaster",
    DOWNLOAD_CSV: "medicity/master/employee_discount_allowedmaster/downloadcsv",
  },
  INVESTIGATIONNABL: {
    CREATE: "medicity/master/create/investigation_nablmaster",
    LIST: "medicity/master/list/investigation_nablmaster",
    UPDATE: "medicity/master/update/investigation_nablmaster",
    DELETE: "medicity/master/delete/investigation_nablmaster",
    DOWNLOAD_CSV: "medicity/master/investigation_nablmaster/downloadcsv",
  },
  OUTSOURCEINVESTIGATION: {
    CREATE: "medicity/master/create/outsource_investigationmaster",
    LIST: "medicity/master/list/outsource_investigationmaster",
    UPDATE: "medicity/master/update/outsource_investigationmaster",
    DELETE: "medicity/master/delete/outsource_investigationmaster",
    DOWNLOAD_CSV: "medicity/master/outsource_investigationmaster/downloadcsv",
  },
  OUTSOURCELAB: {
    CREATE: "medicity/master/create/outsource_labmaster",
    LIST: "medicity/master/list/outsource_labmaster",
    UPDATE: "medicity/master/update/outsource_labmaster",
    DELETE: "medicity/master/delete/outsource_labmaster",
    DOWNLOAD_CSV: "medicity/master/outsource_labmaster/downloadcsv",
  },
  PACKAGE: {
    CREATE: "medicity/master/create/packageinvestigation",
    LIST: "medicity/master/list/packagemaster",
    LIST_BY_ID: "medicity/master/list/packagemaster",
    UPDATE: "medicity/master/update/packagemaster",
    UPDATE_ALL: "medicity/master/update/packagemaster_all",
    BULK_UPDATE: "medicity/master/bulkupdate/packagemaster_cost",
    DELETE: "medicity/master/delete/packagemaster",
    INVESTIGATION_DELETE: "medicity/master/delete/packageinvestigationmaster",
    DOWNLOAD_CSV: "medicity/master/packagemaster/downloadcsv",
  },
  TESTRATE: {
    CREATE: "medicity/master/create/test_ratemaster",
    LIST: "medicity/master/list/test_ratemaster",
    UPDATE: "medicity/master/update/test_ratemaster",
    DELETE: "medicity/master/delete/test_ratemaster",
    DOWNLOAD_CSV: "medicity/master/test_ratemaster/downloadcsv",
    DOWNLOAD_CSV_GENERATE_TEMPLATE:
      "medicity/master/test_ratemaster/generate_csv_template",
    DOWNLOAD_CSV_GENERATE_TEMPLATE_PACKAGE:
      "medicity/master/package_ratemaster/generate_csv_template_for_package",
    UPLOAD_TEST_RATE_CSV:
      "medicity/master/test_ratemaster/upload_test_rate_csv",
    UPLOAD_PACKAGE_RATE_CSV:
      "medicity/master/package_test_ratemaster/upload_package_rate_csv",
    COPY_RATES: "medicity/copy/rate/list",
    CREATE_COPY_RATES_LOG: "medicity/master/create/franchise_copy_rates_log",
  },
  PANELMASTER: {
    CREATE: "medicity/master/create/test_ratemaster",
    LIST: "medicity/master/list/panel_wise_test_ratemaster",
    VIEW_FRANCHISE_RATES_LIST:
      "medicity/master/list/list_panel_wise_test_ratemaster_for_view",
    MEDICITY_FRANCHISE_COPY_RATE_LIST:
      "medicity/master/list/medicity/panel_wise_test_ratemaster",
    FRANCHISE_INVESTIGATION_DETAILS: "medicity/show/investigation/all_detail",
    PENDING_LIST: "medicity/get/pending/rate",
    UPDATE: "medicity/master/update/bulk_update_test_ratemaster",
    MEDICITY_UPDATE:
      "medicity/master/medicity/update/bulk_update_test_ratemaster",
    DELETE: "medicity/master/delete/test_ratemaster",
    DOWNLOAD_CSV: "medicity/master/test_ratemaster/downloadcsv",
    COPY_RATES: "medicity/copy/rate/list",
    SYNC: "medicity/master/franchisemaster/sync_all_investigations_to_test_rate_master",
  },
  INVESTIGATIONHELP: {
    CREATE: "medicity/master/create/investigation_helpmaster",
    LIST: "medicity/master/list/investigation_helpmaster",
    UPDATE: "medicity/master/update/investigation_helpmaster",
    DELETE: "medicity/master/delete/investigation_helpmaster",
    DOWNLOAD_CSV: "medicity/master/investigation_helpmaster/downloadcsv",
  },
  INTERPRETATION: {
    CREATE: "medicity/master/create/investigation_ineterpretationmaster",
    LIST: "medicity/master/list/investigation_ineterpretationmaster",
    UPDATE: "medicity/master/update/investigation_ineterpretationmaster",
    DELETE: "medicity/master/delete/investigation_ineterpretationmaster",
    DOWNLOAD_CSV:
      "medicity/master/investigation_ineterpretationmaster/downloadcsv",
  },
  DELIVERY_DAYS: {
    CREATE: "medicity/master/create/investigation_delivery_daysmaster",
    LIST: "medicity/master/list/investigation_delivery_daysmaster",
    // UPDATE: "medicity/master/update/investigation_delivery_daysmaster",
    UPDATE:
      "medicity/master/update/all_zones/investigation_delivery_daysmaster",
    DELETE: "medicity/master/delete/investigation_delivery_daysmaster",
    DOWNLOAD_CSV:
      "medicity/master/investigation_delivery_daysmaster/downloadcsv",
  },
  INVESTIGATION_COMMENT: {
    CREATE: "medicity/master/create/investigation_commentmaster",
    LIST: "medicity/master/list/investigation_commentmaster",
    UPDATE: "medicity/master/update/investigation_commentmaster",
    DELETE: "medicity/master/delete/investigation_commentmaster",
    DOWNLOAD_CSV: "medicity/master/investigation_commentmaster/downloadcsv",
  },
  INVESTIGATIONDETAILS: {
    CREATE: "medicity/master/create/investigation_detailmaster",
    LIST: "medicity/master/list/investigation_detailmaster",
    UPDATE: "medicity/master/update/investigation_detailmaster",
    DELETE: "medicity/master/delete/investigation_detailmaster",
    DOWNLOAD_CSV: "medicity/master/investigation_detailmaster/downloadcsv",
  },
  DOCTOR: {
    INTERNAL_DOCTOR_LIST: "medicity/master/list/doctormaster_dd",
    DOCTOR_ASSIGN_ROLE: "result/reports/get/employee/assign/doctor",
    SIGNATURE_LIST: "medicity/master/get/download_doctor_signature",
    CREATE: "medicity/master/create/doctormaster",
    LIST: "medicity/master/list/doctormaster",
    LIST_DD: "medicity/master/list/doctormaster",
    UPDATE: "medicity/master/update/doctormaster",
    DELETE: "medicity/master/delete/doctormaster",
    DOWNLOAD_CSV: "medicity/master/doctormaster/downloadcsv",
    ACTIVE: "medicity/master/activate/doctormaster",
  },
  FRANCHISEDETAILS: {
    CREATE: "hrms/master/create/employeefranchisedetail",
    LIST: "hrms/master/list/employeefranchisedetail",
    DELETE: "hrms/master/delete/employeefranchisedetail",
  },
  EMPLOYEE_ROLES: {
    CREATE: "hrms/master/create/employeeroles",
    EMPLOYEE_WISE_ROLES: "hrms/master/list/employeeroles",
    DELETE: "hrms/master/delete/employeeroles",
  },
  DEPARTMENT_ROLES: {
    CREATE: "hrms/master/create/department_role",
    DEPARTMENT_WISE_ROLES: "hrms/master/list/department_role",
    DELETE: "hrms/master/delete/department_role",
  },
  PATIENT: {
    CREATE: "medicity/master/create/patientmaster",
    LIST: "medicity/master/list/patientmaster",
    UPDATE: "medicity/master/update/patientmaster",
    DELETE: "medicity/master/delete/patientmaster",
    DOWNLOAD_CSV: "medicity/master/patientmaster/downloadcsv",
    DOCUMENTTYPELIST: "medicity/master/list/documentmaster",
  },
  APPOINTMENT_PAYMENT: {
    CREATE: "medicity/master/create/online_payments_with_detail",
    ORDER_CREATE: "medicity/master/create/online_payments_create_order",
    CAPTURE_CREATE: "medicity/master/create/capture_online_payment_response",
    LIST: "medicity/master/list/patient_appointment_payment_detail",
    // UPDATE: "medicity/master/update/patientmaster",
    // DELETE: "medicity/master/delete/patientmaster",
    DOWNLOAD_CSV:
      "medicity/master/patient_appointment_payment_detail/downloadcsv",
    // DOCUMENTTYPELIST: "medicity/master/list/documentmaster",
  },
  FRANCHISE_ADVANCE_PAYMENT: {
    CREATE: "accounts/master/create/franchiseadvancepaymentmaster",
    ORDER_CREATE: "accounts/master/create/create_advance_online_payments_order",
    PAYU_ORDER_CREATE:
      "accounts/master/create/create_advance_online_payments_order_payu",
    CAPTURE_CREATE:
      "accounts/master/create/capture_advance_online_payment_response",
    LIST: "medicity/master/list/patient_appointment_payment_detail",
    // UPDATE: "medicity/master/update/patientmaster",
    // DELETE: "medicity/master/delete/patientmaster",
    DOWNLOAD_CSV:
      "medicity/master/patient_appointment_payment_detail/downloadcsv",
    // DOCUMENTTYPELIST: "medicity/master/list/documentmaster",
  },
  ONLINE_PAYMENT_DETAILS: {
    CREATE: "medicity/master/create/online_payments_with_detail",
    ORDER_CREATE: "medicity/master/create/online_payments_create_order",
    CAPTURE_CREATE: "medicity/master/create/capture_online_payment_response",
    VIEW_LIST: "medicity/master/list/online_payment_detail",
    LIST: "medicity/master/list/online_payments",
    // UPDATE: "medicity/master/update/patientmaster",
    DELETE: "medicity/master/delete/online_payment_detail",
    DOWNLOAD_CSV: "medicity/master/online_payment_detail/downloadcsv",
    // DOCUMENTTYPELIST: "medicity/master/list/documentmaster",
  },
  PANNEL_WISE_BUSISSENES_REPORT: {
    // CREATE: "medicity/master/create/documentmaster",
    UPLOADDOCUMENT: "result_entry/upload_patient_investigation_doc",
    CREATEPATIENTLABRESULTENTRY: "result_entry/update_results",
    LIST: "reports/panel/business/report",
    ACCOUNT: "reports/panel/business/account/summary",
    DAILY_SUMMARY: "reports/panel/business/report/daily/summary",
    FRANCHISE_SUPER_FRANCHISE_SUMMARY:
      "reports/panel/bussiness/franchise/summary/report",
    FRANCHISE_SUPER_FRANCHISE_SUMMARY_TWO:
      "reports/panel/business/credit/debit/report",
    //  UPDATE: "medicity/master/update/documentmaster",
    DELETE: "medicity/master/delete/documentmaster",
    DOWNLOAD_CSV: "medicity/master/documentmaster/downloadcsv",
  },
  PAYMENT_TYPE_SEARCH_REPORT: {
    CREATE: "medicity/master/create/documentmaster",
    LIST: "reports/payment/type/search/report",
    //  UPDATE: "medicity/master/update/documentmaster",
    DELETE: "medicity/master/delete/documentmaster",
    DOWNLOAD_CSV: "medicity/master/documentmaster/downloadcsv",
  },
  KYC_VERIFICATION: {
    CREATE: "medicity/master/create/franchise_kyc_document",
    LIST: "medicity/master/list/franchise_kyc_document",
    DELETE: "medicity/master/delete/franchise_kyc_document",
    DOWNLOAD_CSV: "medicity/master/documentmaster/downloadcsv",
  },
  MACHINE_DATA: {
    CREATE: "medicity/master/create/franchise_kyc_document",
    BULK_UPDATE:
      "medicity/master/bulk_update/actual_data_received_from_machine",
    BULK_UPDATE_OBSERVATIONS:
      "medicity/master/bulkupdate_create_from_machine_data/investigation_observation_host_code",
    LIST: "medicity/master/list/actual_data_received_from_machine",
    LIST_BY_BARCODE_ID:
      "medicity/master/list/actual_data_received_from_machine",
    LIST_BY_MACHINE_ID_OBSERVATIONS:
      "medicity/master/host/code/mapped/observation",
    PENDING_OBSERVATION_LIST: "result_entry/appointment/pending/observation",
    DELETE: "medicity/master/delete/franchise_kyc_document",
    DOWNLOAD_CSV: "medicity/master/documentmaster/downloadcsv",
  },
  CREATEDEPARTMENT: "hrms/master/create/department",
  CREATEBRANCH: "hrms/master/create/branch",
  STATEBYCOUNTRY: "medicity/get_state/",
  CITYBYSTATE: "medicity/get_city/",
  ZONELIST: "medicity/zone/master",
  CREATEROLE: "hrms/master/create/roles",
  CREATEDESIGNATION: "hrms/master/create/designation",
  GETDEPARTMENT: "hrms/master/list/department",
  PANELTYPEMASTER: "medicity/master/create/franchisetypes",
  ADDZONEMASTER: "medicity/master/create/zone",
  ADDAREAMASTER: "medicity/master/create/areamaster",
  ADDCIRUCLARMASTER: "medicity/master/create/circularmaster",
  DISCOUNTMASTER: "medicity/master/create/discount_reasonmaster",
  DOCTORMASTER: "medicity/master/create/doctor_degreemaster",
  DOCTORSPECIALIZATION: "medicity/master/create/doctor_specializationmaster",
  BRANCHLISTING: "hrms/master/list/branch/",
  DELETEBRANCH: "hrms/master/delete/branch/",
  CREATENEWREGISTRATION: "medicity/new/registration",
  UPLOADDOCUMENT: "medicity/master/create/patientdocument",
  UPDATEUPLOADDOCUMENT: "medicity/master/update/patientdocument",
  CHECKNEWREGISTRATION: "medicitynew/registration/check",

  OBSERVATION: {
    CREATE: "medicity/master/create/observationmaster",
    LIST: "medicity/master/list/observationmaster",
    UPDATE: "medicity/master/update/observationmaster",
    DELETE: "medicity/master/delete/observationmaster",
    DOWNLOAD_CSV: "medicity/master/observationmaster/downloadcsv",
    UPDATERANGE: "medicity/master/update/observationrange",
    DELETERANGE: "medicity/master/delete/observationrange",
  },
  RESULT_ENTRY_REPORT: {
    // CREATE: "medicity/master/create/documentmaster",
    LIST: "result_entry",
    FRANCHISE_PATIENT_REPORT_LIST: "result_entry/patient_report",
    PDF_LIST: "result_entry/generate/report/pdf",
    GENERATE_PDF_MULTIPLES_INVESTIGATION:
      "result_entry/generate/multiple/investigation/report/pdf",
    QRCODE_PDF: "reports/medicity/reports",
    PDF_DOWNLOAD_LIST: "result_entry/appointment/generate_report_pdf",
    INVESTIGATION_DOCUMENT_DOWNLOAD:
      "result_entry/upload_patient_investigation_doc",
    VIEW_OBSERVATION_LIST: "medicity/new/registration/get_registration_detail",
    CHECK_DOWNLOAD_ALLOWED: "medicitynew/registration/check",
    VIEW_PATIENT_LIST: "medicity/master/list/patientdocument",
    DOWNLOAD_PATIENT_DOCUMENT_LIST:
      "medicity/master/patientdocument/download_document",
    RESULT_ENTRY_DOWNLOAD_PATIENT_DOCUMENT_LIST:
      "result_entry/upload_patient_investigation_doc",
    RESULT_ENTRY_DELETE_PATIENT_DOCUMENT:
      "result_entry/delete_patient_investigation_doc",
    OBSERVATION_LIST: "result_entry/get_investigation_observations",
    ONLY_ORGANISM_LIST: "medicity/master/list/investigationmaster_dd",
    INVESTIGATION_OBSERVATION_DD_LIST:
      "medicity/master/list/investigation_observationmaster_dd",
    INVESTIGATION_OBSERVATION_DD:
      "medicity/master/list/investigation_observationmaster_dd",
    GENERATE_PDF: "result_entry/appointment/generate_report_pdf_node",
    MULTIPLE_GENERATE_PDF:
      "result_entry/appointment/multiple/generate_report_pdf_node",
    DOWNLOAD_INVESTIGATION_DOCUMENT_LIST:
      "result_entry/upload_patient_investigation_doc",
    //  UPDATE: "medicity/master/update/documentmaster",
    DELETE: "medicity/master/delete/documentmaster",
    DOWNLOAD_CSV: "medicity/master/documentmaster/downloadcsv",
    UPDATE_STATUS: "result_entry/bulk_update/update_status",
  },
  COMMISSION_REPORT: {
    CREATE: "medicity/master/create/franchise_commission_master",
    LIST: "medicity/master/list/franchise_commission_master",
    UPDATE: "medicity/master/update/franchise_commission_master/",
    DELETE: "medicity/master/delete/franchise_commission_master",
    DOWNLOAD_CSV: "medicity/master/franchise_commission_master/downloadcsv",
  },
  FRANCHISE_COMMISSION_DETAIL: {
    CREATE: "medicity/master/create/franchise_commission_detail",
    LIST: "medicity/master/list/franchise_commission_detail",
    LIST_BY_ID: "medicity/master/list/franchise_commission_detail_by_id",
  },
  HEADER_FOOTER: {
    CREATE: "medicity/master/create/report_header_footer",
    LIST: "medicity/master/list/report_header_footer/",
    DELETE: "medicity/master/delete/report_header_footer",
  },
  PROFILE_PICTURE: {
    CREATE: "hrms/master/create/employee_profile_picture",
    LIST_BY_ID: "hrms/master/employee_profile_picture/download_document",
    DELETE: "hrms/master/delete/employee_profile_picture",
  },
  MACHINE_MASTER: {
    CREATE: "medicity/master/create/machinemaster",
    LIST: "medicity/master/list/machinemaster",
    UPDATE: "medicity/master/update/machinemaster",
    DELETE: "medicity/master/delete/machinemaster",
    DOWNLOAD_CSV: "medicity/master/machinemaster/downloadcsv",
  },
  OBSERVATION_HOST_CODE_MASTER: {
    CREATE: "medicity/master/create/investigation_observation_host_code",
    LIST: "medicity/master/list/investigation_observation_host_code",
    UPDATE: "medicity/master/update/investigation_observation_host_code",
    BULK_UPDATE:
      "medicity/master/bulkupdate_create/investigation_observation_host_code",
    DELETE: "medicity/master/delete/investigation_observation_host_code",
    DOWNLOAD_CSV:
      "medicity/master/investigation_observation_host_code/downloadcsv",
    OBSERVATION_ID_MACHINE_ID:
      "medicity/master/list/investigation_observation_host_code_by_observation_id_machine_id",
  },
  REPORT_ROLE: {
    CREATE: "result/reports/create/roles",
    LIST: "result/reports/get/roles",
    UPDATE: "result/reports/update/roles",
    DELETE: "result/reports/delete/roles",
    DOWNLOAD_CSV: "hrms/master/reportrole/downloadcsv",
  },
  ASSIGN_ROLE: {
    CREATE: "result/reports/assign/roles",
    LIST: "result/reports/get/assign/roles",
    LIST_BY_ID: "result/reports/get/employee/assign/roles",
    UPDATE: "result/reports/update/assign/roles",
    DELETE: "result/reports/delete/assigns/role",
    DOWNLOAD_CSV: "result_entry/assign/report/rolesdownloadcsv",
  },
  FIREBASE: {
    UPDATE: "hrms/master/update/employee_notifications",
    CREATE: "hrms/master/reset_firebase_token/employee",
    EMPLOYEE_NOTIFICATION: "hrms/master/employee/send_notification",
    EMPLOYEE_NOTIFICATION_LIST: "hrms/master/list/employee_notification",
    EMPLOYEE_NOTIFICATION_LISTS: "hrms/master/list/employee_notifications",
  },
  EMPLOYEEALLOCATE: {
    CREATE: "hrms/master/create/employee_zone_allocation",
    BULK_CREATE: "hrms/master/bulkcreate/employee_zone_allocation",
    LIST: "hrms/master/list/employee_zone_allocation/zone_dd",
    UPDATE: "hrms/master/update/employeecategorymaster",
    DELETE: "hrms/master/delete/employee_zone_allocation",
    DOWNLOAD_CSV: "hrms/master/employeecategorymaster/downloadcsv",
  },
  PACKAGE_COPY_RATE: {
    CREATE: "medicity/master/create/franchise_package_rate",
    BULK_CREATE: "medicity/master/bulkcreateupdate/franchise_package_rate",
    BULK_CREATE_ONLY: "medicity/master/bulkcreateonly/franchise_package_rate",
    LIST: "medicity/master/list/franchise_wise_package_rate_list",
    SYNC: "medicity/master/franchisemaster/sync_all_package_to_rate_master",
    VIEW_FRANCHISE_PACKAGE_RATES_LIST:
      "medicity/master/list/view_franchise_wise_package_rate_list",
  },
  VENDOR: {
    CREATE: "inventory/master/create/vendormaster",
    LIST: "inventory/master/list/vendormaster",
    VENDOR_LIST_BY_ID: "inventory/master/list/vendormaster_by_id",
    UPDATE: "inventory/master/update/vendormaster",
    DELETE: "inventory/master/delete/vendormaster",
    DOWNLOAD_CSV: "inventory/master/vendormaster/downloadcsv",
  },
  PRODUCT: {
    CREATE: "inventory/master/create/productmaster",
    LIST: "inventory/master/list/productmaster",
    PRODUCT_LIST_BY_ID: "inventory/master/list/productmaster_by_id",
    UPDATE: "inventory/master/update/productmaster",
    DELETE: "inventory/master/delete/productmaster",
    DOWNLOAD_CSV: "inventory/master/productmaster/downloadcsv",
  },
  PRODUCT_TYPE: {
    CREATE: "inventory/master/create/producttypemaster",
    LIST: "inventory/master/list/producttypemaster",
    LIST_DD: "inventory/master/list/producttypemaster_dd",
    PRODUCT_LIST_BY_ID: "inventory/master/list/productmaster_by_id",
    UPDATE: "inventory/master/update/producttypemaster",
    DELETE: "inventory/master/delete/producttypemaster",
    DOWNLOAD_CSV: "inventory/master/producttypemaster/downloadcsv",
  },
  UNIT: {
    LIST_DD: "inventory/master/list/productunitmaster_list_dd",
    CREATE: "inventory/master/create/productunitmaster",
  },
  ATTENDANCE: {
    CREATE: "inventory/master/create/productmaster",
    LIST: "hrms/master/list/loginlog",
    UPDATE: "inventory/master/update/productmaster",
    DELETE: "inventory/master/delete/productmaster",
    DOWNLOAD_CSV: "inventory/master/productmaster/downloadcsv",
  },
  EMPLOYEE_ACTIVITY: {
    CREATE_MARK_LOGIN: "hrms/master/loginlog/mark_login",
    CREATE_MARK_LOGOUT: "hrms/master/loginlog/mark_logout",
  },
  INVENTORY_TERMS_CONDITION: {
    CREATE: "inventory/master/create/terms_condition",
    LIST: "inventory/master/list/terms_condition",
    TERMS_CONDITION_LIST_BY_ID: "inventory/master/list/terms_condition_by_id",
    UPDATE: "inventory/master/update/terms_condition",
    DELETE: "inventory/master/delete/terms_condition",
    DOWNLOAD_CSV: "inventory/master/terms_condition/downloadcsv",
  },
  PURCHASE_ORDER: {
    CREATE: "inventory/master/create/full/purchase_order",
    LIST: "inventory/master/list/purchase_order",
    LIST_BY_ID: "inventory/master/list/purchase_order",
    UPDATE: "inventory/master/update/full_purchase_order",
    APPROVE_UPDATE: "inventory/master/update/approve_purchase_order",
    RECEIVE_UPDATE: "inventory/master/purchase_order/mark_receive_order",
    DELETE: "inventory/master/delete/purchase_order",
    DOWNLOAD_CSV: "inventory/master/purchase_order/downloadcsv",
  },
  STOCKIN: {
    CREATE: "inventory/master/stockin_stockout_inventory/inventory_stockin",
    LIST: "inventory/master/list/stockin_stockout_inventory",
    PRODUCT_LIST_BY_ID: "inventory/master/list/productmaster_by_id",
    UPDATE: "inventory/master/update/stockin_stockout_inventory",
    DELETE: "inventory/master/delete/stockin_stockout_inventory",
    DOWNLOAD_CSV: "inventory/master/stockin_stockout_inventory/downloadcsv",
  },
  STOCKOUT: {
    CREATE: "inventory/master/stockin_stockout_inventory/inventory_stockout",
    LIST: "inventory/master/list/stockin_stockout_inventory",
    PRODUCT_LIST_BY_ID: "inventory/master/list/productmaster_by_id",
    UPDATE: "inventory/master/update/stockin_stockout_inventory",
    DELETE: "inventory/master/delete/stockin_stockout_inventory",
    DOWNLOAD_CSV: "inventory/master/stockin_stockout_inventory/downloadcsv",
  },
  EMPLOYEE_LEAVE: {
    CREATE: "hrms/master/create/employee_leaves_application",
    LIST: "hrms/master/list/employee_leaves_application",
    LEAVE_LEDGER_SUMMARY_LIST:
      "hrms/master/list/employee_leaves_ledger_summary",
    LEAVE_HISTORY_LIST: "hrms/master/list/employee_leaves_history",
    LEAVE_HISTORY_BY_ID_LIST: "hrms/master/list/employee_leaves_history",
    LIST_BY_ID: "hrms/master/list/employee_leaves_application",
    UPDATE: "hrms/master/update/employee_leaves_application",
    APPROVE_UPDATE: "inventory/master/update/approve_purchase_order",
    RECEIVE_UPDATE: "inventory/master/purchase_order/mark_receive_order",
    DELETE: "hrms/master/delete/employee_leaves_application",
    DOWNLOAD_CSV: "inventory/master/purchase_order/downloadcsv",
  },
  PAYMENT_LEDGER: {
    LIST: "accounts/payment/ledger/list",
    HISTORY_LIST: "accounts/payment/ledger/history/list",
  },
  COMMISSION_LEDGER: {
    LIST: "accounts/commissions/list",
    HISTORY_LIST: "accounts/commissions/history/list",
    REPORT_LIST: "accounts/commission/monthly/list",
    COMMISSION_LEDGER_CARDS_LIST: "accounts/commission/dashboard",
  },
  CREDIT_TRANSFER: {
    CREATE: "accounts/transfer/credit",
    LIST: "accounts/credit/transfer/list",
  },
  LAB_DEPARTMENT_IP_RATE: {
    CREATE: "medicity/master/create/lab_department_doctor_ip_rate",
    LIST: "medicity/master/list/lab_department_ip_rate",
    UPDATE: "medicity/master/update/lab_department_ip_rate",
    DELETE: "medicity/master/delete/lab_department_ip_rate",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  LAB_DEPARTMENT_IP_RATE_DOCTOR: {
    CREATE: "medicity/master/create/lab_department_doctor_ip_rate",
    LIST: "medicity/master/list/lab_department_doctor_ip_rate",
    UPDATE: "medicity/master/update/lab_department_doctor_ip_rate",
    DELETE: "medicity/master/delete/lab_department_doctor_ip_rate",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  LAB_DEPARTMENT_WISE_IP_RATES: {
    CREATE: "medicity/master/create/lab_department_ip_rate",
    LIST: "medicity/master/lab_department_ip_rate/all_ip_rates",
    BULK_UPDATE: "medicity/master/bulk_update_create/lab_department_ip_rate",
    DELETE: "medicity/master/delete/lab_department_ip_rate",
    SYNC: "medicity/master/lab_department_ip_rate/sync_package_and_department",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  LAB_DEPARTMENT_WISE_COORDINATOR_RATES: {
    CREATE: "medicity/master/create/lab_department_patient_coordinators_rate",
    LIST: "medicity/master/lab_department_patient_coordinators_rate/all_ip_rates",
    LIST_DEPARTMENT_WISE_RATE:
      "medicity/master/list/lab_department_patient_coordinators_rate",
    BULK_UPDATE:
      "medicity/master/bulk_update_create/lab_department_patient_coordinators_rate",
    DELETE: "medicity/master/delete/lab_department_patient_coordinators_rate",
    SYNC: "medicity/master/lab_department_patient_coordinators_rate/sync_package_and_department",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  LAB_DEPARTMENT_COORDINATOR_RATE: {
    CREATE: "medicity/master/create/patient_coordinators_rate",
    LIST: "medicity/master/list/patient_coordinators_rate",
    UPDATE: "medicity/master/update/patient_coordinators_rate",
    DELETE: "medicity/master/delete/patient_coordinators_rate",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  DOCTOR_IP_CALCULATION: {
    CREATE: "medicity/master/create/areamaster",
    LIST: "medicity/master/list/doctor_ip_calculation",
    DETAILS_LIST: "medicity/master/list/doctor_ip_calculation_detail",
    UPDATE: "medicity/master/update/areamaster",
    DELETE: "medicity/master/delete/areamaster",
    DOWNLOAD_CSV: "medicity/master/areamaster/downloadcsv",
  },
  PATIENT_COORDINATOR_CHARGES: {
    CREATE: "medicity/master/create/areamaster",
    LIST: "medicity/master/list/appointment_patient_coordinators_charge",
    DETAILS_LIST:
      "medicity/master/list/appointment_patient_coordinators_charge_detail",
    UPDATE: "medicity/master/update/areamaster",
    DELETE: "medicity/master/delete/areamaster",
    DOWNLOAD_CSV: "medicity/master/areamaster/downloadcsv",
  },
  DOCTOR_TEST_CHARGES: {
    CREATE: "medicity/master/create/doctor_test_charge",
    LIST: "medicity/master/list/doctor_test_charge",
    DETAILS_LIST: "medicity/master/list/doctor_ip_calculation_detail",
    UPDATE: "medicity/master/update/doctor_test_charge",
    DELETE: "medicity/master/delete/areamaster",
    DOWNLOAD_CSV: "medicity/master/areamaster/downloadcsv",
  },
  DOCTOR_PERFORMING_CHARGES: {
    CREATE: "medicity/master/create/doctor_test_charge",
    LIST: "medicity/master/list/performing_doctor_charge",
    DETAILS_LIST: "medicity/master/list/doctor_ip_calculation_detail",
    UPDATE: "medicity/master/update/doctor_test_charge",
    DELETE: "medicity/master/delete/areamaster",
    DOWNLOAD_CSV: "medicity/master/areamaster/downloadcsv",
  },
  DOCTOR_PERFORMING_CHARGES_DETAILS: {
    CREATE: "medicity/master/create/doctor_test_charge",
    LIST: "medicity/master/list/performing_doctor_charge_detail",
    DETAILS_LIST: "medicity/master/list/performing_doctor_charge_detail",
    UPDATE: "medicity/master/update/doctor_test_charge",
    DELETE: "medicity/master/delete/areamaster",
    DOWNLOAD_CSV: "medicity/master/areamaster/downloadcsv",
  },
  MEMBERSHIP_CARD: {
    CREATE: "medicity/master/create/membership_card",
    LIST: "medicity/master/list/membership_card",
    ORDERS_LIST: "medicity/master/list/patient_membership_order_detail",
    LIST_DD: "medicity/master/list/membership_card_dd",
    UPDATE: "medicity/master/update/membership_card",
    DELETE: "medicity/master/delete/membership_card",
    DOWNLOAD_CSV: "hrms/master/branch/downloadcsv",
  },
  MEMBERSHIP_RATES: {
    CREATE: "medicity/master/create/test_ratemaster",
    LIST: "medicity/master/list/membership_rate",
    MEDICITY_FRANCHISE_COPY_RATE_LIST:
      "medicity/master/list/medicity/panel_wise_test_ratemaster",
    FRANCHISE_INVESTIGATION_DETAILS: "medicity/show/investigation/all_detail",
    PENDING_LIST: "medicity/get/pending/rate",
    UPDATE: "medicity/master/bulk_add_update/membership_rate",
    MEMBERSHIP_CREATE:
      "medicity/master/create/patient_membership_order_detail/with_payments",
    MEMBERSHIP_UPDATE: "medicity/master/update/patient_membership_order_detail",
    MEMBERSHIP_UPGRADE:
      "medicity/master/create/patient_membership_order_detail/upgrade_cards",
    MEMBERSHIP_LIST_DETAIL:
      "medicity/master/list/patient_membership_order_detail",
    MEDICITY_UPDATE:
      "medicity/master/medicity/update/bulk_update_test_ratemaster",
    DELETE: "medicity/master/delete/test_ratemaster",
    DOWNLOAD_CSV: "medicity/master/test_ratemaster/downloadcsv",
    COPY_RATES: "medicity/copy/rate/list",
    SYNC: "medicity/master/franchisemaster/sync_all_investigations_to_test_rate_master",
  },
  PATIENT_COORDINATOR_AGENTS: {
    CREATE: "hrms/master/create/patient_coordinator_agent",
    LIST: "hrms/master/list/patient_coordinator_agent",
    UPDATE: "hrms/master/update/patient_coordinator_agent",
    DELETE: "hrms/master/delete/employee",
    DOWNLOAD_CSV: "hrms/master/employee/downloadcsv",
  },
  NAVBAR_SECTION: {
    CREATE: "hrms/master/create/navbar_section_master",
    LIST: "hrms/master/list/navbar_section_master",
    UPDATE: "hrms/master/update/navbar_section_master",
    DELETE: "hrms/master/delete/navbar_section_master",
    DOWNLOAD_CSV: "hrms/master/navbar_section_master/downloadcsv",
  },
  ROLE_SECTION_DETAIL: {
    CREATE: "hrms/master/create/role_section_detail",
    LIST: "hrms/master/list/role_section_detail",
    LIST_ID: "hrms/master/list/role_section_detail",
    UPDATE: "hrms/master/update/navbar_section_master",
    DELETE: "hrms/master/delete/role_section_detail",
    DOWNLOAD_CSV: "hrms/master/navbar_section_master/downloadcsv",
  },
  COLLECTION_REPORT: {
    DISCOUNT_REPORT_LIST: "b2c_reports/mis_reports/discount_report",
    COLLECTION_REPORT_LIST: "b2c_reports/mis_reports/collection_report",
    OUTSTANDING_REPORT_LIST: "b2c_reports/mis_reports/outstanding_report",
    ALL_PAYMENT_REPORT_LIST: "b2c_reports/mis_reports/all_payments_report",
    CARD_COLLECTION_REPORT_LIST:
      "b2c_reports/mis_reports/card_collection_report",
    BOOKING_COLLECTION_REPORT_LIST:
      "b2c_reports/mis_reports/booking_collection_report",
    INVESTIGATION_REPORT_LIST:
      "b2c_reports/mis_reports/investigation_wise_report",
    FRANCHISE_INVOICE_REPORT_LIST:
      "invoice_reports/invoice_reports/franchise_invoice_report",
    CREATE_FRANCHISE_INVOICE_REPORT_LIST:
      "accounts/master/create/full_franchise_booking_invoice",
  },
  FRANCHISE_INVOICE_REPORT: {
    CREATE_FRANCHISE_INVOICE_REPORT_LIST:
      "accounts/master/create/full_franchise_booking_invoice",
    LIST_FRANCHISE_INVOICE_REPORT_LIST:
      "accounts/master/list/franchise_booking_invoice",
  },
  PATIENT_COORDINATOR_AGENTS_ONBOARDING_APPLICATION: {
    CREATE:
      "hrms/master/create/patient_coordinator_agent_onboarding_application",
    LIST: "hrms/master/list/patient_coordinator_agent_onboarding_application",
    UPDATE:
      "hrms/master/update/patient_coordinator_agent_onboarding_application",
    DELETE:
      "hrms/master/delete/patient_coordinator_agent_onboarding_application",
    APPROVAL:
      "hrms/master/patient_coordinator_agent_onboarding_application/approve_application",
    DOWNLOAD_CSV: "hrms/master/employee/downloadcsv",
  },
  DOCTOR_ONBOARDING_APPLICATION: {
    CREATE: "medicity/master/create/doctors_master_onboarding_application",
    LIST: "medicity/master/list/doctors_master_onboarding_application",
    UPDATE: "medicity/master/update/doctors_master_onboarding_application",
    DELETE: "medicity/master/delete/doctors_master_onboarding_application",
    APPROVAL:
      "medicity/master/doctors_master_onboarding_application/approve_application",
    DOWNLOAD_CSV: "hrms/master/employee/downloadcsv",
  },
  FRANCHISE_ONBOARDING_APPLICATION: {
    CREATE: "medicity/create/franchise_onboarding_application/master",
    LIST: "medicity/franchise_master_onboarding_application/master/list",
    UPDATE:
      "medicity/master/update/franchise_master_onboarding_application_onboarding_application",
    DELETE:
      "medicity/master/delete/franchise_master_onboarding_application_onboarding_application",
    APPROVAL:
      "medicity/master/franchise_master_onboarding_application/approve_application",
    DOWNLOAD_CSV: "hrms/master/employee/downloadcsv",
  },
  SAMPLE_COLLECT_BY_BARCODE: {
    CREATE: "medicity/master/sample/barcode_search_and_mark_collected",
  },
  TAT_REPORT: {
    LIST: "reports/report/investigation_tat/report",
    LIST_GRAPHICAL: "reports/report/investigation_tat/graph_report",
  },
  APPOINTMENT_CANCELLATIONS: {
    CREATE: "hrms/master/create/branch",
    LIST: "medicity/master/list/patient_appointment_cancellation_master",
    DETAIL: "medicity/master/list/patient_appointment_cancellation_detail",
    UPDATE: "hrms/master/update/branch",
    DELETE: "hrms/master/delete/branch",
    DOWNLOAD_CSV: "hrms/master/branch/downloadcsv",
  },
  MARKETING_PERSON_BUSINESS_REPORT: {
    CREATE: "hrms/master/create/branch",
    LIST: "reports/marketing_person/stats/franchise_report",
    DETAIL: "reports/marketing_person/detail/franchise_detail",
    UPDATE: "hrms/master/update/branch",
    DELETE: "hrms/master/delete/branch",
    DOWNLOAD_CSV: "hrms/master/branch/downloadcsv",
  },
  EMPLOYEE_TARGET: {
    CREATE: "hrms/master/create/employee_target",
    LIST: "hrms/master/list/employee_target",
    UPDATE: "hrms/master/update/employee_target",
    DELETE: "hrms/master/delete/employee_target_by_id",
    DOWNLOAD_CSV: "hrms/master/branch/downloadcsv",
    BY_EMPLOYEE_ID: "hrms/master/list/employee_target",
  },
  DOCTOR_CLINIC_ROUTER: {
    CREATE: "opd/master/create/doctor_clinic_master",
    LIST: "opd/master/list/doctor_clinic_master",
    UPDATE: "opd/master/update/doctor_clinic_master",
    DELETE: "opd/master/delete/doctor_clinic_master",
    DOWNLOAD_CSV: "opd/master/doctor_clinic_master/downloadcsv",
    DROPDOWN: "opd/master/list/doctor_clinic_master_dd",
  },
  DOCTOR_OPD_CHARGE_ROUTER: {
    LIST: "opd/master/list/doctor_opd_charge",
    CREATE: "opd/master/create/doctor_opd_charge",
    UPDATE: "opd/master/update/doctor_opd_charge",
    DELETE: "opd/master/delete/doctor_opd_charge",
    DOWNLOAD_CSV: "opd/master/doctor_opd_charge/downloadcsv",
  },
  DOCTOR_SCHEDULE_ROUTER: {
    CREATE: "opd/master/create/doctor_schedule",
    LIST: "opd/master/list/doctor_schedule",
    UPDATE: "opd/master/update/doctor_schedule",
    DELETE: "opd/master/delete/doctor_schedule",
    DOWNLOAD_CSV: "opd/master/doctor_schedule/downloadcsv",
    DROPDOWN: "opd/master/list/doctor_schedule_dd",
  },
  DOCTOR_OPD_BILL_ITEM: {
    CREATE: "opd/master/create/doctor_opd_bill_item",
    LIST: "opd/master/list/doctor_opd_bill_item",
    UPDATE: "opd/master/update/doctor_opd_bill_item",
    DELETE: "opd/master/delete/doctor_opd_bill_item",
    DOWNLOAD_CSV: "opd/master/doctor_opd_bill_item/downloadcsv",
    DROPDOWN: "opd/master/list/doctor_opd_bill_item_dd",
    DETAIL: "opd/master/list/doctor_opd_bill_item_full_detail",
  },
  DOCTOR_OPD_BILL_PAYMENT: {
    CREATE: "opd/master/create/doctor_opd_bill_payment",
    LIST: "opd/master/list/doctor_opd_bill_payment",
    UPDATE: "opd/master/update/doctor_opd_bill_payment",
    DELETE: "opd/master/delete/doctor_opd_bill_payment",
    DOWNLOAD_CSV: "opd/master/doctor_opd_bill_payment/downloadcsv",
    DROPDOWN: "opd/master/list/doctor_opd_bill_payment_dd",
    DETAIL: "opd/master/list/doctor_opd_bill_payment_full_detail",
  },
  DOCTOR_OPD_APPOINTMENT: {
    CREATE: "opd/master/create/doctor_opd_appointment",
    LIST: "opd/master/list/doctor_opd_appointment",
    UPDATE: "opd/master/update/doctor_opd_appointment",
    DELETE: "opd/master/delete/doctor_opd_appointment",
    DOWNLOAD_CSV: "opd/master/doctor_opd_appointment/downloadcsv",
    DROPDOWN: "opd/master/list/doctor_opd_appointment_dd",
    DETAIL: "opd/master/list/doctor_opd_appointment_full_detail",
  },
};
